<template>
  <!--<transition name="fade-in">-->
  <div class="col-lg-4">
    <div class="movie-card">
      <div class="movie-card-image">
        <img :class="{ 'cursor-pointer': isSearched }" @click="isSearched ? getRecommended() : null" :src="image" :alt="movie.title">
      </div>
      <div class="infos-container">
        <div class="info">
          <transition name="fade" mode="out-in">
            <div v-if="!showPlot" class="info-inner" key="info">
              <div>
                <h2>{{ movie.title }} <span>({{ date }})</span></h2>
                <p>{{ genres }}</p>
              </div>
              <div>
                <transition name="fade" mode="out-in">
                  <p v-if="showInfos" key="value">{{ rtRating }}</p>
                  <p v-else class="placeholder-1" key="placeholder">&nbsp;</p>
                </transition>
                <transition name="fade" mode="out-in">
                  <p v-if="showInfos" key="value">{{ imdbRating }}</p>
                  <p v-else class="placeholder-3" key="placeholder">&nbsp;</p>
                </transition>
              </div>
            </div>
            <!-- <div v-if="showPlot" class="plot" key="plot">{{ plot }}</div> -->
          </transition>
        </div>
        <div class="buttons-container">
          <button class="button" v-show="isSearched" @click="getRecommended">Search similar movie</button>
          <div v-show="!isSearched">
            <transition name="fade" mode="out-in">
              <div v-if="showInfos" key="value">
                <button class="button" v-show="showInfos && !isSearched" @click="showMovieDetails">Details</button>
                <!-- <button class="button margin-left" v-show="showInfos && !isSearched" @click="showPlot = !showPlot">Plot</button> -->
              </div>
              <p v-else class="button placeholder-2" key="placeholder">&nbsp;</p>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--</transition>-->
</template>

<script>
import * as types from '../component-types';
import api from '../api/omdb';

export default {
  props: ['movie', 'type'],
  data() {
    return {
      infos: {
        plot: null, imdbRating: null, imdbId: null, rtRating: null,
      },
      showInfos: false,
      showPlot: false,
    };
  },
  computed: {
    image() {
      return this.movie.poster_path
        ? `https://image.tmdb.org/t/p/w154/${this.movie.poster_path}`
        : null;
    },
    date() {
      return this.movie.release_date
        ? this.movie.release_date.split('-')[0]
        : null;
    },
    isSearched() {
      return this.type === types.SEARCHED_MOVIE;
    },
    genres() {
      return this.$store.getters.genresString(this.movie.genre_ids);
    },
    plot() {
      return this.infos.plot ? `${this.infos.plot}` : null;
    },
    imdbRating() {
      return this.infos.imdbRating ? `Vote: ${this.infos.imdbRating}` : null;
    },
    rtRating() {
      return this.infos.rtRating ? `${this.infos.rtRating} liked it` : null;
    },
    imdbLink() {
      return this.infos.imdbId
        ? `https://www.imdb.com/title/${this.infos.imdbId}/`
        : null;
    },
  },
  methods: {
    getRecommended() {
      this.$store.dispatch('recommendMovies', this.movie);
      this.$store.dispatch('removeUnusedMovies', this.movie);
    },
    async getInfos() {
      await api.getMoreInfos(this.movie, (infos) => {
        this.infos = infos;
        this.movie.infos = infos;
        this.showInfos = true;
      });
    },
    showMovieDetails() {
      this.$store.dispatch('toggleMovieDetails');
      this.$store.dispatch('setMovieDetails', this.movie);
    },
  },
  created() {
    this.getInfos();
  },
};
</script>

<style lang="scss" scoped>
div.col-lg-4 {
  margin-bottom: 10px;

  @media (min-width: $lg) {
    margin-bottom: 20px;
  }
}

.placeholder {
  display: flex;
  align-items: center;
  color: transparent;
  // height: 16px;
  background-color: $gray;
  border-radius: 4px !important;
  &:hover {
    background-color: $gray !important;
  }
}

.placeholder-1 {
  @extend .placeholder;
  width: 40%;
  content: "placeholder";
}

.placeholder-2 {
  @extend .placeholder;
  width: 50%;
  content: "placeholder";
}

.placeholder-3 {
  @extend .placeholder;
  width: 60%;
  content: "placeholder";
}

p {
  margin: 5px 0 0;
  font-size: 1em;

  &.button {
    margin: 0;
  }
}

.movie-card {
  display: flex;
  height: 100%;
  border-radius: 6px;
  box-shadow: $shadow-level-2;
  background-color: white;

  h2 {
    font-size: 1.5em;
    margin: 0;

    span {
      color: #777777;
      font-size: 0.7em;
    }
  }

  img {
    border-radius: 6px 0 0 6px;
    max-height: 100%;
    width: 154px;
  }

  .dummy-80 {
    background-color: #bfbfbf;
    height: 12px;
    width: 80px;
    border-radius: 2px;
  }

  .dummy-70 {
    @extend .dummy-80;
    width: 70px;
  }
}

.movie-card-image {
  display: flex;
  width: auto;
}

.infos-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
}

.info {
  height: 100%;
  position: relative;
  padding: 15px 10px 10px;

  div {
    width: 100%;
  }
}

.info-inner {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  align-items: flex-start;
  justify-content: space-between;
}

div.plot {
  position: absolute;
  width: calc(100% - 20px);
  height: calc(100% - 25px);
  text-align: justify;
}

.buttons-container {
  border-top: 1px solid $gray;
  padding: 8px;
}

.button {
  display: inline-flex;
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;
  font-weight: 700;
  color: $primary-color;
  text-transform: uppercase;
  transition: all 0.1s ease-in;
  user-select: none;

  a {
    color: $primary-color;
    text-decoration: none;
    user-select: none;
  }

  @media (min-width: $md) {
    &:hover {
      background-color: $light-gray;
    }
  }

  &:active {
    background-color: $light-gray;
  }
}

p.margin-left {
  margin-left: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.1s ease-in;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
